import { useNavigate } from "react-router-dom";

export default function Dashboard() {
  const navigate = useNavigate();

  return (
    <>
      <div className="screen active">
        <div className="page-head">
          <div>
            <h1 id="db-greeting">Good morning, Rohit</h1>
            <div className="ph-sub">
              Verma Textiles Pvt Ltd · here's where things stand today
            </div>
          </div>
          <div className="page-actions">
            <button
              className="btn btn-ghost"
              onClick={() => navigate("/add-ca-bulk")}
            >
              Bulk upload
            </button>
            <button
              className="btn btn-gold"
              onClick={() => navigate("/company-add-fund")}
            >
              Add fund
            </button>
          </div>
        </div>
        <div className="stat-grid stat-h">
          <div className="stat-card">
            <div
              className="sc-icon"
              style={{
                background:
                  "linear-gradient(150deg,var(--violet-light),var(--violet-dark))",
              }}
            >
              <svg width={17} height={17} viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 3l8 4v5c0 5-3.4 8.5-8 9-4.6-.5-8-4-8-9V7l8-4z"
                  stroke="#fff"
                  strokeWidth="1.6"
                />
              </svg>
            </div>
            <div className="sc-txt">
              <div className="sc-val" id="db-fund">
                ₹4,62,381
              </div>
              <div className="sc-label">Available fund</div>
              <div className="sc-meta warn" id="db-fund-meta">
                ₹1,50,000 awaiting credit
              </div>
            </div>
          </div>
          <div className="stat-card">
            <div
              className="sc-icon"
              style={{
                background:
                  "linear-gradient(150deg,#5CF0D4,var(--teal-dark))",
              }}
            >
              <svg width={17} height={17} viewBox="0 0 24 24" fill="none">
                <path
                  d="M5 13l4 4L19 7"
                  stroke="#04342C"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="sc-txt">
              <div className="sc-val" id="db-today">
                ₹31,000
              </div>
              <div className="sc-label">Today's payments</div>
              <div className="sc-meta" id="db-today-meta">
                1 payment processed
              </div>
            </div>
          </div>
          <div className="stat-card">
            <div
              className="sc-icon"
              style={{
                background: "linear-gradient(150deg,#FFD98A,var(--gold))",
              }}
            >
              <svg width={17} height={17} viewBox="0 0 24 24" fill="none">
                <rect
                  x={5}
                  y={11}
                  width={14}
                  height={9}
                  rx={2}
                  stroke="#4A2E00"
                  strokeWidth="1.6"
                />
                <path
                  d="M8 11V8a4 4 0 018 0v3"
                  stroke="#4A2E00"
                  strokeWidth="1.6"
                />
              </svg>
            </div>
            <div className="sc-txt">
              <div className="sc-val" id="db-pending">
                7
              </div>
              <div className="sc-label">Pending bills</div>
              <div className="sc-meta" id="db-pending-meta">
                ₹1,04,449 outstanding
              </div>
            </div>
          </div>
          <div className="stat-card">
            <div
              className="sc-icon"
              style={{
                background: "linear-gradient(150deg,#FF8FA6,var(--red))",
              }}
            >
              <svg width={17} height={17} viewBox="0 0 24 24" fill="none">
                <path
                  d="M12 8v5M12 16h.01"
                  stroke="#4A0A18"
                  strokeWidth={2}
                  strokeLinecap="round"
                />
                <circle
                  cx={12}
                  cy={12}
                  r={9}
                  stroke="#4A0A18"
                  strokeWidth="1.6"
                />
              </svg>
            </div>
            <div className="sc-txt">
              <div className="sc-val" id="db-due">
                3
              </div>
              <div className="sc-label">Due this week</div>
              <div className="sc-meta warn" id="db-due-meta">
                ₹50,700 to pay by 08 Aug
              </div>
            </div>
          </div>
        </div>
        <div className="card wf-card">
          <div className="wf-head">
            <div>
              <div className="card-title">Payment workflow</div>
              <div className="card-sub">
                From saved account to reconciled payment. Select a step to
                open it.
              </div>
            </div>
          </div>
          <div className="wf" id="db-workflow">
            <button
              className="wf-step done"
              onClick={() => navigate("/saved-ca")}
            >
              <div className="wf-dot">✓</div>
              <div className="wf-title">Add accounts</div>
              <div className="wf-meta">
                <strong>9</strong> consumer accounts saved
              </div>
            </button>
            <button
              className="wf-step attn"
              onClick={() => navigate("/due-date-calendar")}
            >
              <div className="wf-dot">2</div>
              <div className="wf-title">Check due dates</div>
              <div className="wf-meta">
                <strong>3</strong> bills due this week
              </div>
              <span className="wf-tag">Due soon</span>
            </button>
            <button className="wf-step " onClick={() => navigate("/bill-review")}>
              <div className="wf-dot">3</div>
              <div className="wf-title">Review bills</div>
              <div className="wf-meta">
                <strong>7</strong> unpaid · ₹1,04,449
              </div>
            </button>
            <button
              className="wf-step attn"
              onClick={() => navigate("/approval")}
            >
              <div className="wf-dot">4</div>
              <div className="wf-title">Approve batch</div>
              <div className="wf-meta">
                <strong>2 batches</strong> · ₹1,00,599
              </div>
              <span className="wf-tag">Needs approval</span>
            </button>
            <button className="wf-step " onClick={() => navigate("/reconciliation")}>
              <div className="wf-dot">5</div>
              <div className="wf-title">Reconcile</div>
              <div className="wf-meta">
                <strong>2</strong> payments to match
              </div>
            </button>
          </div>
        </div>
        <div className="grid-2 db-row">
          <div className="card">
            <div className="card-head-row">
              <div>
                <div className="card-title">Recent activity</div>
                <div className="card-sub">
                  Latest transactions across all billers
                </div>
              </div>
              <button
                className="btn btn-ghost btn-sm"
                onClick={() => navigate("/transaction-history")}
              >
                View all
              </button>
            </div>
            <div className="table-wrap">
              <table className="data-table" id="db-recent-table">
                <tbody>
                  <tr>
                    <th>Biller</th>
                    <th>Account</th>
                    <th className="tright">Amount</th>
                    <th className="tright">Status</th>
                  </tr>
                  <tr>
                    <td>
                      Maharashtra State Electricity Distbn Co Ltd
                      <div
                        style={{
                          fontSize: "10.5px",
                          color: "var(--text-faint)",
                        }}
                      >
                        29 Aug, 10:12 AM
                      </div>
                    </td>
                    <td className="mono">400213556621</td>
                    <td className="tright mono">₹31,000</td>
                    <td className="tright">
                      <span className="pill pill-success">Success</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      HDFC Bank FASTag
                      <div
                        style={{
                          fontSize: "10.5px",
                          color: "var(--text-faint)",
                        }}
                      >
                        28 Aug, 4:40 PM
                      </div>
                    </td>
                    <td className="mono">MH04PN2299</td>
                    <td className="tright mono">₹5,000</td>
                    <td className="tright">
                      <span className="pill pill-success">Success</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Jio Postpaid
                      <div
                        style={{
                          fontSize: "10.5px",
                          color: "var(--text-faint)",
                        }}
                      >
                        27 Aug, 11:02 AM
                      </div>
                    </td>
                    <td className="mono">9911002234</td>
                    <td className="tright mono">₹2,999</td>
                    <td className="tright">
                      <span className="pill pill-failed">Failed</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Airtel Postpaid (Fetch and Pay)
                      <div
                        style={{
                          fontSize: "10.5px",
                          color: "var(--text-faint)",
                        }}
                      >
                        25 Aug, 9:14 AM
                      </div>
                    </td>
                    <td className="mono">9820044120</td>
                    <td className="tright mono">₹1,499</td>
                    <td className="tright">
                      <span className="pill pill-success">Success</span>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      MTNL Mumbai Lease Circuit
                      <div
                        style={{
                          fontSize: "10.5px",
                          color: "var(--text-faint)",
                        }}
                      >
                        22 Aug, 3:20 PM
                      </div>
                    </td>
                    <td className="mono">LC-7731100</td>
                    <td className="tright mono">₹38,000</td>
                    <td className="tright">
                      <span className="pill pill-pending">Pending</span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="card">
            <div className="card-head-row">
              <div>
                <div className="card-title">Due next</div>
                <div className="card-sub">Earliest unpaid bills</div>
              </div>
              <button
                className="btn btn-ghost btn-sm"
                onClick={() => navigate("/due-date-calendar")}
              >
                Calendar
              </button>
            </div>
            <div id="db-due-list">
              <div className="due-row">
                <div className="due-date soon">
                  <b>05</b>
                  <span>Aug</span>
                </div>
                <div className="due-info">
                  <div>Warehouse 2</div>
                  <span>Maharashtra State Electricity Distbn Co Ltd</span>
                </div>
                <div className="due-amt">₹24,500</div>
              </div>
              <div className="due-row">
                <div className="due-date soon">
                  <b>05</b>
                  <span>Aug</span>
                </div>
                <div className="due-info">
                  <div>Head office</div>
                  <span>Adani Electricity Mumbai Limited</span>
                </div>
                <div className="due-amt">₹18,200</div>
              </div>
              <div className="due-row">
                <div className="due-date soon">
                  <b>08</b>
                  <span>Aug</span>
                </div>
                <div className="due-info">
                  <div>Truck fleet — Unit 4</div>
                  <span>ICICI Bank FASTag</span>
                </div>
                <div className="due-amt">₹8,000</div>
              </div>
              <div className="due-row">
                <div className="due-date">
                  <b>12</b>
                  <span>Aug</span>
                </div>
                <div className="due-info">
                  <div>Leased line — HQ</div>
                  <span>MTNL Mumbai Lease Circuit</span>
                </div>
                <div className="due-amt">₹42,000</div>
              </div>
            </div>
            <div className="cover-box">
              <div className="cover-top">
                <span>Fund cover for all dues</span>
                <strong className="mono" id="db-cover-pct">
                  100%
                </strong>
              </div>
              <div className="progress-track">
                <div
                  className="progress-fill"
                  id="db-cover-fill"
                  style={{ width: "100%" }}
                />
              </div>
              <div className="cover-note" id="db-cover-note">
                ₹3,57,932 left after paying every due bill
              </div>
            </div>
          </div>
        </div>
        <div className="card" style={{ marginTop: 18 }}>
          <div className="card-head-row">
            <div>
              <div className="card-title">Bill value by category</div>
              <div className="card-sub">
                Paid and due amounts across saved consumer accounts
              </div>
            </div>
            <div className="legend">
              <span>
                <i style={{ background: "var(--violet)" }} />
                Paid
              </span>
              <span>
                <i style={{ background: "var(--gold)" }} />
                Due
              </span>
            </div>
          </div>
          <div id="db-cat-bars">
            <div className="cat-row">
              <div className="cat-name">Electricity</div>
              <div className="cat-track" title="Paid ₹31,000 · Due ₹49,100">
                <i
                  style={{
                    width: "38.70162297128589%",
                    background: "var(--violet)",
                  }}
                />
                <i
                  style={{
                    width: "61.298377028714114%",
                    background: "var(--gold)",
                  }}
                />
              </div>
              <div className="cat-amt">₹80,100</div>
            </div>
            <div className="cat-row">
              <div className="cat-name">Landline Postpaid</div>
              <div className="cat-track" title="Paid ₹0 · Due ₹45,850">
                <i style={{ width: "0%", background: "var(--violet)" }} />
                <i
                  style={{
                    width: "57.24094881398252%",
                    background: "var(--gold)",
                  }}
                />
              </div>
              <div className="cat-amt">₹45,850</div>
            </div>
            <div className="cat-row">
              <div className="cat-name">FASTag</div>
              <div className="cat-track" title="Paid ₹5,000 · Due ₹8,000">
                <i
                  style={{
                    width: "6.242197253433209%",
                    background: "var(--violet)",
                  }}
                />
                <i
                  style={{
                    width: "9.987515605493133%",
                    background: "var(--gold)",
                  }}
                />
              </div>
              <div className="cat-amt">₹13,000</div>
            </div>
            <div className="cat-row">
              <div className="cat-name">Mobile Postpaid</div>
              <div className="cat-track" title="Paid ₹0 · Due ₹1,499">
                <i style={{ width: "0%", background: "var(--violet)" }} />
                <i
                  style={{
                    width: "1.8714107365792758%",
                    background: "var(--gold)",
                  }}
                />
              </div>
              <div className="cat-amt">₹1,499</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
